export const FILTERS_BTN = [
  {
    text: 'Default',
    activeFilter: 'default',
  },
  {
    text: 'Name Asc',
    activeFilter: 'nameAsc',
  },
  {
    text: 'Name Desc',
    activeFilter: 'nameDesc',
  },
  {
    text: 'E-mail Asc',
    activeFilter: 'emailAsc'
  },
  {
    text: 'E-mail Desc',
    activeFilter: 'emailDesc'
  },
  {
    text: 'Status Asc',
    activeFilter: 'statusAsc'
  },
  {
    text: 'Status Desc',
    activeFilter: 'statusDesc'
  }
];

export const ADD_TASK = 'ADD_TASK';
export const CHANGE_FILTER = 'CHANGE_FILTER';
export const SHOW_PAGE = 'SHOW_PAGE';
export const LOG_IN = 'LOG_IN';
